import { auth } from "../firebase/firebaseConfig";
import { API_BASE } from "./config";

export class SoccerAdminResearchError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export async function loadSoccerAdminResearch(filters = {}, { fetchImpl = fetch, identity = null } = {}) {
  const user = identity?._fb || auth.currentUser;
  if (!user) throw new SoccerAdminResearchError("Sign in is required.", 401);
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) params.set(key, String(value));
  });
  const request = async (refresh) => {
    const token = await user.getIdToken(refresh);
    return fetchImpl(`${API_BASE}/admin/soccer/research?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` },
      credentials: "include",
      cache: "no-store",
    });
  };
  let response = await request(false);
  if (response.status === 401) response = await request(true);
  if (!response.ok) {
    throw new SoccerAdminResearchError(
      response.status === 403 ? "Administrator access is required." : "Soccer admin research is unavailable.",
      response.status,
    );
  }
  return response.json();
}
